import { useEffect, useState } from "react";
import TitleLine from "../../../components/Assets/TitleLine/TitleLine";
import DoctorApprovalList from "../../../components/Doctor/DoctorApprovalList/DoctorApprovalList";
import FormTitle from "../../../components/Form/FormTitle/FormTitle";
import { useUserContext } from "../../../contexts/UserContext";
import { getForm } from "../../../scripts/dataHandlers";
import classes from "./DoctorLandingPage.module.css";
import axios from "axios";
import { FormData } from "../../../contexts/interfaces";
import { useErrorContext } from "../../../contexts/ErrorContext";

const DoctorLandingPage = () => {
  // User from context used for viewing/hiding topBar
  const { user } = useUserContext();

  const [applications, setApplications] = useState<FormData[]>([]);

  const { handleError } = useErrorContext();

  useEffect(() => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const getApplicationsData = async () => {
      // Get all applications (for this user) from backend
      const res =
        user && (await getForm(user.id, null, "waiting", null, source));
      if (res?.status === 200) {
        setApplications([...res.data.result]);
      } else {
        handleError(res, "GetFormFailed");
      }
    };

    // If user is loggedIn, get data
    user && getApplicationsData();

    return () => source.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    applications && (
      <div className="mainContainer">
        <div className={classes.mainContainer}>
          <div className={classes.innerContainer}>
            <FormTitle />
            <TitleLine />
            <DoctorApprovalList
              applications={applications}
              setApplications={setApplications}
            />
          </div>
        </div>
      </div>
    )
  );
};

export default DoctorLandingPage;
